import React from "react";

/* global HTMLDivElement */
type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

interface SpacerProps {
  size?: number | string;
}

const Spacer = ({ size = 16, ...props }: SpacerProps & DivProps) => {
  return (
    <div
      style={{
        flex: 1,
        flexBasis: size,
        height: size,
        width: size,
      }}
      {...props}
    />
  );
};

export default Spacer;
